export default "__VITE_ASSET__eb1d7a82__"